import { GET_TERMINE_DESIGN_SETTINGS } from '@/domain/termine/hooks/graphql/queries';
import { useQuery } from '@apollo/client/react';

export function useDesignSettings() {
  const { data, error } = useQuery(GET_TERMINE_DESIGN_SETTINGS, {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });
  const managerSettings = data?.termine_manager;

  if (!data || error) {
    return {
      error: error ?? new Error('no data'),
    };
  }

  if (managerSettings?.__typename === 'TermineManager') {
    return {
      managerSettings,
    };
  } else {
    return { error: new Error('Invalid managerSettings') };
  }
}
